<template>
  <component :is="resolvedIcon" v-bind="$attrs" :filled="filled" :font-controlled="fontControlled">
    <slot />
  </component>

</template>

<script>
import { computed, defineAsyncComponent } from 'vue';

const componentCache = new Map()

export default {
  name: 'OSvg',
  inheritAttrs: false,
  props: {
    // Provided by nuxt-svgo when using customComponent or legacy usage
    icon: {
      type: [Object, Function],
      required: false,
      default: undefined
    },
    // New: name of the svg in assets/svg (e.g., "danger" or "icons/danger")
    svg: {
      type: String,
      required: false,
      default: undefined
    },
    filled: {
      type: Boolean,
      default: false
    },
    fontControlled: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const resolvedIcon = computed(() => {
      if (props.icon) return props.icon
      if (!props.svg) return null
      const name = normalizeName(props.svg)
      if (!componentCache.has(name)) {
        componentCache.set(
          name,
          defineAsyncComponent(() => import(`~/assets/svg/${name}.svg?component`))
        )
      }
      return componentCache.get(name)
    })

    return { resolvedIcon }
  }
}

function normalizeName(input) {
  let name = String(input || '').trim()
  if (!name) return name
  name = name.replace(/\.svg$/i, '')
  return name
}
</script>
